<template>
    <v-container v-if="null != order" fluid>
        <v-row justify="center">
            <v-col md="6">
                <order-edit-form
                    v-bind:title="`Editing order #${order.id}`"
                    v-bind:order="order"
                    v-on:submit="submit"
                    v-on:cancel="$router.go(-1)"
                    v-on:servicecharge-retrieved="onServicechargeRetrieved"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import orderApi from '@/api/orderApi';
import snackbar from '@/utils/snackbar';

export default {
    components: {
        'order-edit-form': () => import('@/views/rest/OrderEditForm.vue')
    },
    data() {
        return {
            order: null
        };
    },
    methods: {
        async submit() {
            const response = await orderApi.updateOrder(
                this.order.id,
                this.order
            );
            this.$router.push({
                name: 'rest-order-show',
                params: { order_id: response.data.order.id }
            });
            snackbar.show('Order updated', 'success');
        },
        onServicechargeRetrieved(servicecharge) {
            this.order.service_charge =
                null != servicecharge ? servicecharge.service_charge : null;
        }
    },
    async beforeRouteEnter(to, from, next) {
        const orderId = to.params.order_id;
        const response = await orderApi.getOrder(orderId);
        next(vm => (vm.order = response.data.order));
    }
};
</script>
